import  { useMemo } from "react";
import { useIntl } from "umi";
import { LANGUAGE_EN } from "@home/_config/config";
import { renderRegion } from "./renderRegion";

export const useFilterList = () => {
  const { locale } = useIntl(); // 中英切换方法
  const isEN = locale === LANGUAGE_EN;
  const { formatMessage } = useIntl();
  
  const { filterConfigList } = useMemo(() => {

    // 筛选器名称映射，和后端核对后，后端暂不支持名称配置话，前端写死
    const FILTER_NAME_MAP = {
      'region_country': {
        nameEN: 'Region',
        nameCN: '地区',
        default: {
          market: ['255'],
          region_type: 'market',
          region: [],
        },
        view_type: 'cascade',
        intitShow: true,
        hasKeyChange: true,
        visible: 1,
        render: renderRegion,
      },
      'campaign_name': {
        nameEN: 'Campaign',
        nameCN: '活动',
        default: ['255'],
        view_type: 'multiple',
        intitShow: true,
        isPopupContainer: false,
        matchButtonWidth: false,
        overlayClassName: 'dbh-studio-kol-active-selector',
        visible: 1,
        radioOptions: [{
          value: '255',
          text: formatMessage({id: 'dbh_studio_filter_all' }),
          info: ''
        }],
      },

      'fix_language': {
        nameEN: 'Language',
        nameCN: '语言',
        default: ['255'],
        view_type: 'multiple',
        intitShow: true,
        isPopupContainer: false,
        visible: 1,
        radioOptions: [{
          value: '255',
          text: formatMessage({id: 'dbh_studio_filter_all' }),
          info: ''
        }],
      },

      'channel_name': {
        nameEN: 'Channel',
        nameCN: '渠道',
        default: ['255'],
        view_type: 'multiple',
        intitShow: false,
        isPopupContainer: false,
        visible: 1,
        radioOptions: [{
          value: '255',
          text: formatMessage({id: 'dbh_studio_filter_all' }),
          info: ''
        }],
      },

      'platform': {
        nameEN: 'Platform',
        nameCN: '平台',
        default: ['255'],
        view_type: 'multiple',
        intitShow: false,
        isPopupContainer: false,
        visible: 1,
        radioOptions: [{
          value: '255',
          text: formatMessage({id: 'dbh_studio_filter_all' }),
          info: ''
        }],
      },
      'content': {
        nameEN: 'Content',
        nameCN: '内容',
        default: ['255'],
        view_type: 'multiple',
        intitShow: false,
        isPopupContainer: false,
        visible: 1,
        radioOptions: [{
          value: '255',
          text: formatMessage({id: 'dbh_studio_filter_all' }),
          info: ''
        }],
      },
      'format': {
        nameEN: 'Format',
        nameCN: '格式',
        default: ['255'],
        view_type: 'multiple',
        intitShow: false,
        isPopupContainer: false,
        visible: 1,
        radioOptions: [{
          value: '255',
          text: formatMessage({id: 'dbh_studio_filter_all' }),
          info: ''
        }],
      },
    };

    return {
      filterConfigList: FILTER_NAME_MAP,
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEN]);

  return {
    filterConfigList,
  };
};

